import { currencySymbol } from '@/utils';

/** The currencies a rate or agreement is entered in. */
export const COST_CURRENCIES = ['GBP', 'USD', 'EUR'] as const;

/** Today as an ISO date, in UTC — the day rates are compared against. */
export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

/** "£0.000125" — a per-unit rate keeps every significant decimal, which
 * `formatMoney`'s locale default (three places) would round away. */
export function formatRate(value: number, currency: string): string {
  const amount = value.toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  });
  return `${currencySymbol(currency) || `${currency} `}${amount}`;
}

/** A non-negative decimal as typed: digits, optionally one point and up to
 * six places. */
export function isDecimal(value: string, places = 6): boolean {
  return new RegExp(`^\\d+(\\.\\d{1,${places}})?$`).test(value.trim());
}

/** Whole cents, so sums of typed money compare exactly. */
export function toCents(value: string | null | undefined): number {
  return Math.round(Number.parseFloat(value ?? '0') * 100);
}
